import { Card, CardContent, CardHeader } from "@mui/material";
import { SchemaForm } from "./SchemaForm";

interface Props {
  domainKey: string;
  description: string;
  jsonSchema: Record<string, unknown>;
}

export const SettingsCard = ({domainKey, description, jsonSchema}: Props) => (
  <Card>
    <CardHeader title={description}/>
    <CardContent>
      <SchemaForm jsonSchema={jsonSchema} namePrefix={domainKey}/>
    </CardContent>
  </Card>
);
